import React, {useEffect, useState} from 'react';
import {Link} from 'react-router';
import {Button, Icon, MenuListItem, SplitButton} from '@albert-io/atomic';
import {getFeatureFlagStatus} from 'client/components/FeatureFlag/FeatureFlag.react';
import {history} from 'client/history';
import NewFolderModal from 'components/PracticeView/FoldersModal/NewFolderModal/NewFolderModal.react';

import './assignments-folders-wrapper.scss';

type AssignmentsFoldersWrapperProps = {
  children: React.ReactNode;
};

const AssignmentsFoldersWrapper = ({children}: AssignmentsFoldersWrapperProps) => {
  const [isNavUpdatesEnabled, setIsNavUpdatesEnabled] = useState(null);
  const [isFoldersModalOpen, setIsFoldersModalOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    getFeatureFlagStatus('primary_nav_updates').then(setIsNavUpdatesEnabled);
  }, []);

  if (!isNavUpdatesEnabled) {
    return <>{children}</>;
  }

  return (
    <div className='u-display_flex'>
      <div className='u-display_flex u-flex-direction_column u-pad_4 assignments-folders-sidebar'>
        <div>
          <SplitButton>
            <Button
              onClick={() => history.pushState(null, '/assignment-builder/create-assignment')}
            >
              <Icon icon='plus' className='u-mar-r_1' />
              New Assignment
            </Button>
            <Button onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
              <Icon icon='caret-down' />
            </Button>
          </SplitButton>
          {isDropdownOpen && (
            <Button
              color='secondary'
              onClick={() => setIsFoldersModalOpen(true)}
              className='assignments-folders-sidebar__new-folder'
            >
              <Icon icon='plus' className='u-mar-r_1' />
              New Folder
            </Button>
          )}
        </div>
        <MenuListItem
          as={Link}
          to='/assignments'
          className='assignments-folders-sidebar__item u-mar-t_3'
        >
          <Icon icon={['fal', 'file-alt']} className='nav-submenu_assignments-icon' />
          Assignments
        </MenuListItem>
        <MenuListItem as={Link} to='/saved' className='assignments-folders-sidebar__item'>
          <Icon icon={['far', 'folder-open']} className='u-mar-r_1' />
          Folders
        </MenuListItem>
      </div>
      <div style={{flex: 1}}>{children}</div>
      {isFoldersModalOpen && <NewFolderModal handleClose={() => setIsFoldersModalOpen(false)} />}
    </div>
  );
};

export default AssignmentsFoldersWrapper;
